import script from "./MainHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainHeader.vue?vue&type=script&lang=ts&setup=true"

import "./MainHeader.vue?vue&type=style&index=0&id=5f11bf2d&scoped=true&lang=scss"

import exportComponent from "/var/www/prod_sara2/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f11bf2d"]])

export default __exports__